import Vue from 'vue';
import Vuex from 'vuex';

import submission from './modules/submission';
import user from './modules/user';
import submissionView from './modules/submission-view';
import ui from './modules/ui';
import windowMedia from './modules/window-media';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const storeConfig = {
  modules: {
    submission,
    user,
    submissionView,
    ui,
    windowMedia
  },
  strict: debug,
};


const store = new Vuex.Store(storeConfig);

export default store;
